/* eslint-disable no-prototype-builtins */

import { Component } from 'react';
import {connect} from 'react-redux';
import {Col, Container, Row} from 'react-bootstrap';
import InlineCKEditor from '../../common/editor/inline-editor';
import ImageEditor from '../../common/editor/image-editor';
import VideoEditor from '../../common/editor/video-editor';
import {checkPermission} from '../../common/guards/can';
import {loadPageContent, loadSecondaryPageContent} from '../../../actions/content';
import PageTitle from '../../common/page-title/index';
import Extensions from './content-editor-extensions';
import {TOGGLE_EDIT_CONTENT} from '../../../reducers/viewReducer';
import './styles.css';
import IgniteUkLogo from '../../../assets/img/ignite_logo_black.png';

class ContentPage extends Component {
  handleContentSaved = () => {
  };

  UNSAFE_componentWillMount() {
    const {dispatch, match} = this.props;
    let { pageSlug } = match.params;
    if (match.url === '/privacy-policy.html') {
      pageSlug = 'privacy-policy';
    }
    if (match.url === '/ignite-by-imperial') {
      pageSlug = 'ignite-by-imperial';
    }
    dispatch(loadPageContent(`api/pages/${pageSlug}`))
      .then(() => {
        const anchor = document.URL.split('#')[1];
        const element = document.getElementById(anchor);
        if (anchor && element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
        if (checkPermission('edit', 'Page') && this.isEditAccordingToPath()) {
          dispatch({type: TOGGLE_EDIT_CONTENT, payLoad: true});
        } else {
          this.props.dispatch({type: TOGGLE_EDIT_CONTENT, payLoad: false});
        }
      });
    if (match.params.pageSlug === 'terms-conditions' && this.props.loggedIn) {
      dispatch(loadSecondaryPageContent(`api/pages/${pageSlug}-2`))
        .then(() => {
          if (checkPermission('edit', 'Page') && this.isEditAccordingToPath()) {
            dispatch({type: TOGGLE_EDIT_CONTENT, payLoad: true});
          } else {
            this.props.dispatch({type: TOGGLE_EDIT_CONTENT, payLoad: false});
          }
        });
    }
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: TOGGLE_EDIT_CONTENT,
      payLoad: false
    });
  }

  isEditAccordingToPath() {
    return this.props.match.path.split('/')[2] === 'edit';
  }

  render() {
    const {attributes} = this.props.page;
    const {attributes: secondaryAttributes} = this.props.secondaryPage;
    const {pageSlug} = this.props.match.params;
    const {contents, secondaryContents, loggedIn} = this.props;

    const editors = {
      text: {
        component: InlineCKEditor,
        props: {
          config: {
            width: '100%',
            height: '100%'
          },
          activeClass: 'content-editor',
        },
      },
      image: {component: ImageEditor},
      video: {component: VideoEditor},
    };

    return (
      <Container fluid className="content-page user-inner-container">
        <Row>
          <Col
            lg={12}
            style={ loggedIn &&
                    (!window.location.pathname.match('/team/') &&
                    !window.location.pathname.match('/admin/')) ?
                    { textAlign: 'center' } :
                    { textAlign: 'left' } }
          >
            {!loggedIn && <img src={IgniteUkLogo} alt="Ignite UK" />}
            <PageTitle>
              {attributes && attributes.name}
            </PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <Extensions page={pageSlug} show={this.isEditAccordingToPath()}/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            {attributes && Object.keys(contents)
              .map((key) => {
                const editor = editors[contents[key].content_type];
                const EditorComponent = editor.component;
                const props = editor.hasOwnProperty('props') && editor.props;

                return (
                  <EditorComponent
                    contents={contents[key]}
                    identifier={key}
                    key={key}
                    onContentSaved={this.handleContentSaved}
                    {...props}
                  />
                );
              })}
          </Col>
        </Row>
        {pageSlug === 'terms-conditions' && loggedIn && this.isEditAccordingToPath() && (
        <Row>
          <Col
            lg={12}
            style={ loggedIn &&
                  (!window.location.pathname.match('/team/') &&
                  !window.location.pathname.match('/admin/')) ?
                  { textAlign: 'center' } :
                  { textAlign: 'left' } }
          >
            {!loggedIn && <img src={IgniteUkLogo} alt="Ignite UK" />}
            <PageTitle>
              {secondaryAttributes && secondaryAttributes.name}
            </PageTitle>
          </Col>
        </Row>
      )}
        {pageSlug === 'terms-conditions' && loggedIn && (
        <Row>
          <Col lg={12}>
            {secondaryAttributes && Object.keys(secondaryContents)
            .map((key) => {
              const editor = editors[secondaryContents[key].content_type];
              const EditorComponent = editor.component;
              const props = editor.hasOwnProperty('props') && editor.props;

              return (
                <EditorComponent
                  contents={secondaryContents[key]}
                  identifier={key}
                  key={key}
                  onContentSaved={this.handleContentSaved}
                  {...props}
                />
              );
            })}
          </Col>
        </Row>
)}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  contents: state.content.list,
  secondaryContents: state.secondaryContent.list,
  page: state.content.page,
  secondaryPage: state.secondaryContent.page,
  edit: state.viewConfig.editContent,
  loggedIn: !!state.viewConfig.profile.id
});

export default connect(mapStateToProps)(ContentPage);
